import createRoute from '@widesk-ui/tools/createRoute';
import UserModel   from '@models/account/UserModel';

export default createRoute.splitView('/users', 'account', 'UserSplitView', UserModel.localize('plural'));